module.exports = __webpack_public_path__ + "img/ctf-careem.004d3405.png";